var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowButtonsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    width: 46,
    height: 46,
    rx: 23,
    transform: "rotate(90 46 0)",
    fill: "fillColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H24V27H29L23 33L17 27H22V13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowButtonsvg);
export default __webpack_public_path__ + "static/media/ArrowButtonsvg.ce2815d36750cc8f33129d5b796b4ec1.svg";
export { ForwardRef as ReactComponent };